import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";
import { formatMinutesDuration } from "./formatters";

export default function SupportPortalDialogs({ portal }) {
  const {
    clients: {
      adminClientForm,
      handleAddTmaPackage,
      handleDeleteClient,
      isDeleteClientDialogOpen,
      isTmaPackageDialogOpen,
      selectedAdminClient,
      setIsDeleteClientDialogOpen,
      setIsTmaPackageDialogOpen,
      setTmaPackageForm,
      tmaPackageForm,
    },
    tickets: {
      handleDeleteTicket,
      isDeleteTicketDialogOpen,
      setIsDeleteTicketDialogOpen,
    },
    ui: { loading },
  } = portal;

  return (
    <>
      <AlertDialog open={isDeleteClientDialogOpen} onOpenChange={setIsDeleteClientDialogOpen}>
        <AlertDialogContent className="support-alert-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Supprimer ce client ?</AlertDialogTitle>
            <AlertDialogDescription>
              {adminClientForm.full_name
                ? `Cette action bloquera l'accès de ${adminClientForm.full_name}. Ses tickets, notifications et pièces jointes resteront conservées.`
                : "Cette action bloquera l'accès de ce client. Ses tickets, notifications et pièces jointes resteront conservées."}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={loading}>Annuler</AlertDialogCancel>
            <AlertDialogAction
              className="support-alert-danger"
              onClick={(event) => {
                event.preventDefault();
                handleDeleteClient();
              }}
              disabled={loading}
            >
              {loading ? "Blocage..." : "Bloquer l'accès"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={isDeleteTicketDialogOpen} onOpenChange={setIsDeleteTicketDialogOpen}>
        <AlertDialogContent className="support-alert-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Supprimer ce ticket ?</AlertDialogTitle>
            <AlertDialogDescription>
              Cette action supprimera le ticket, ses notifications et ses pièces jointes. Elle est réservée aux tickets ouverts ou en cours de traitement.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={loading}>Annuler</AlertDialogCancel>
            <AlertDialogAction
              className="support-alert-danger"
              onClick={(event) => {
                event.preventDefault();
                handleDeleteTicket();
              }}
              disabled={loading}
            >
              {loading ? "Suppression..." : "Supprimer le ticket"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={isTmaPackageDialogOpen} onOpenChange={setIsTmaPackageDialogOpen}>
        <AlertDialogContent className="support-alert-dialog support-tma-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Ajouter un forfait de maintenance</AlertDialogTitle>
            <AlertDialogDescription>
              Ajoutez une nouvelle ligne de forfait TMA pour ce client.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <div className="support-tma-dialog-body">
            <label className="support-field-block">
              <span>Client</span>
              <input className="form-input" value={selectedAdminClient?.full_name || ""} disabled />
            </label>
            <label className="support-field-block">
              <span>Nom du forfait</span>
              <input
                className="form-input"
                value={tmaPackageForm.label}
                onChange={(event) => setTmaPackageForm({ ...tmaPackageForm, label: event.target.value })}
                placeholder="Ex: TMA Juillet 2026"
              />
            </label>
            <label className="support-field-block">
              <span>Minutes incluses</span>
              <input
                className="form-input"
                type="number"
                min="1"
                step="1"
                value={tmaPackageForm.minutes}
                onChange={(event) => setTmaPackageForm({ ...tmaPackageForm, minutes: event.target.value })}
                placeholder="600"
              />
            </label>
            <div className="support-tma-dialog-summary">
              <span>Nouveau forfait</span>
              <strong>{formatMinutesDuration(Number(tmaPackageForm.minutes || 0))}</strong>
            </div>
          </div>
          <AlertDialogFooter>
            <AlertDialogCancel disabled={loading}>Annuler</AlertDialogCancel>
            <AlertDialogAction
              onClick={(event) => {
                event.preventDefault();
                handleAddTmaPackage();
              }}
              disabled={loading}
            >
              {loading ? "Ajout..." : "Ajouter le forfait"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
